import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'
import SubmissionHistoryPage from './pages/SubmissionHistoryPage'

const SubmissionPage = lazy(() => import('./pages/SubmissionPage'))
const SubmissionDetailPage = lazy(() => import('./pages/SubmissionDetailPage'))

export const SUBMISSION_ROUTES: RouteObject[] = [
  {
    path: '/submissions',
    element: (
      <>
        <AppHelmet title='Submissions' />
        <AuthProtectedLayout>
          <AppLayout>
            <PageSuspenseFallback>
              <SubmissionPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/submissions/:submissionCode',
        element: (
          <>
            <AppHelmet title='View Submission' />
            <PageSuspenseFallback>
              <SubmissionDetailPage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/submissions/:submissionCode/history',
        element: (
          <>
            <AppHelmet title='Submission History' />
            <PageSuspenseFallback>
              <SubmissionHistoryPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
